export default __webpack_public_path__ + "static/media/18.f00abc55.JPG";